/**
 * Layer A (per-client) game enablement, baked at build time.
 *
 * Reads the generated `CLIENT_GAMES` map (written by `pnpm platform:generate`) so frontend
 * apps can gate route registration / nav by the games their client deployed. When the
 * generated module hasn't been produced for a client it defaults to all-enabled (permissive),
 * matching the rest of the platform-config behaviour.
 */
import type { GameKey } from '@low6-pickem/platform-config';
import { CLIENT_GAMES } from './generated/client-games';

export type ClientGameKey = GameKey;

/** Whether a game is enabled for this client instance. Permissive (true) if unspecified. */
export function isClientGameEnabled(game: ClientGameKey): boolean {
  return CLIENT_GAMES[game] !== false;
}
